import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Button, Grid, SubmitButton, Dialog, UserForm } from '../../../..';
import { Debug } from '../../../../Molecules/Forms/Debug';
import { makeStyles } from '@material-ui/core/styles';
var franchiseUserSchema = Yup.object().shape({
  users: Yup.array().of(Yup.object().shape({
    name: Yup.string().min(2, 'Too Short!').required('Campo obligatorio'),
    email: Yup.string().email()
  }))
});
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      'flex-wrap': 'wrap'
    },
    flex: {
      display: 'flex',
      'justify-content': 'space-between'
    },
    w50: {
      width: '50%'
    },
    taxName: {
      'margin-right': '30px',
      width: '40%'
    },
    actions: {
      display: 'flex',
      padding: '30px',
      'justify-content': 'flex-end'
    },
    mr30: {
      'margin-right': '30px'
    }
  };
});

var DialogFranchiseUser = function DialogFranchiseUser(_ref) {
  var translation = _ref.translation,
      variant = _ref.variant,
      createUser = _ref.createUser,
      editUser = _ref.editUser,
      users = _ref.users,
      onClose = _ref.onClose,
      open = _ref.open,
      props = _objectWithoutProperties(_ref, ["translation", "variant", "createUser", "editUser", "users", "onClose", "open"]);

  var initialValues = {
    users: [{
      name: '',
      email: ''
    }]
  };
  var classes = useStyles();
  var title = '';

  if (variant === 'edit') {
    title = 'Edit User';
  } else if (variant === 'add') {
    title = 'Add User';
  }

  var contentDialog = function contentDialog() {
    return /*#__PURE__*/React.createElement(Grid, {
      container: true,
      className: classes.root
    }, /*#__PURE__*/React.createElement(Formik, {
      initialValues: users || initialValues,
      validationSchema: franchiseUserSchema,
      onSubmit: function onSubmit(values) {
        if (variant === 'add') {
          // console.log('values on submit', values);
          createUser(values);
        } else if (variant === 'edit') {
          editUser(values);
        }

        onClose();
      },
      render: function render(_ref2) {
        var values = _ref2.values,
            setFieldValue = _ref2.setFieldValue,
            handleBlur = _ref2.handleBlur,
            isValid = _ref2.isValid,
            isSubmitting = _ref2.isSubmitting;
        return /*#__PURE__*/React.createElement(Form, {
          "data-cy": "add-user",
          className: classes.form
        }, /*#__PURE__*/React.createElement(Grid, {
          container: true,
          className: classes.root
        }, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          md: 12,
          className: classes.editor
        }, /*#__PURE__*/React.createElement(UserForm, {
          values: values,
          mode: variant
        })), variant !== 'view' && /*#__PURE__*/React.createElement(Grid, {
          container: true,
          className: classes.actions
        }, /*#__PURE__*/React.createElement(Button, {
          "data-cy": "cancel",
          type: "button",
          size: "medium",
          className: classes.mr30,
          color: "secondary",
          variant: "outlined",
          onClick: onClose
        }, translation ? translation.buttons.cancel : 'Cancelar'), /*#__PURE__*/React.createElement(Button, {
          "data-cy": "submit",
          size: "medium",
          className: classes.mr30,
          color: "primary",
          variant: "outlined",
          disabled: !isValid || isSubmitting,
          component: SubmitButton,
          type: "submit"
        }, translation ? translation.buttons.save : 'Guardar'))));
      }
    }));
  };

  return [/*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "lg",
    title: title,
    open: open,
    onClose: onClose,
    mode: variant
  }, contentDialog())];
};

export { DialogFranchiseUser };